import { AssetUpdatedEvent } from '../event/asset-updated.event';
const assetUpdatedProjections = {
    [AssetUpdatedEvent.name]: (event, state) => {
        const payload = event.getPayload();
        return {
            ...state,
            attributes: payload.attributes,
        };
    },
};
export default assetUpdatedProjections;
//# sourceMappingURL=asset-updated.projection.js.map